// extracted by mini-css-extract-plugin
export default {"cta":"MG-z","disabled":"NG-z"};